// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"accordion_wrapper__GM6lQ","item":"accordion_item__zZLkb"};